import { store } from '@/store/store';
import $http from '@/http';
import Util from '@/util';
import helpers from '@/util/helpers';
import callChannelType from '@/constants/callChannelType';
import eventBus from '@/EventBus';

var retryCount = {
  call: 0,
  api: 0
};

async function initNeoWebRtc() {
  const parseLoginToken = Util.parseLoginToken();
  if (!parseLoginToken) return;

  const callServerType = parseLoginToken.callServerType;
  if (!callServerType) return;

  try {
    // 콜 모드 세팅
    if (callServerType && callServerType.indexOf('NEO_WEB_RTC') > -1) {
      store.commit('setCallMode', callChannelType.NEO_WEB_RTC);
    }

    // 콜 서버 타입 세팅
    if (callServerType) {
      store.commit('setCallServerType', callServerType);
    } else {
      store.dispatch('recheckCallServerAndRefresh');
    }

    // 콜 포트번호 세팅
    store.commit('setCallPort', parseLoginToken.callServerProcessPort || '3019');

    // 상담사 상태 관리용 상담사 상태목록 세팅
    store.dispatch('getCallWorkingStatusList');

    // 콜 API url 세팅
    store.commit('setCallApiUrl', helpers.findCallApiUrl(callServerType));

    // 콜 브랜드 세팅
    const brandList = await getBrandList();
    store.commit('setCallBrandList', brandList);

    // 콜 상담사 정보 세팅
    // 1. 상담사 정보 존재 여부 값
    // 2. 내선번호
    // 3. 상담사 계정 사용 가능 여부
    // 4. AgentGroup 값
    // 5. 콜 브랜드ID
    await setNeoWebRtcAgentInfo();

    store.dispatch('logInWebPhone');
    store.dispatch('runWebPhoneLoginCheck');

    // 콜 웹소켓 url 세팅
    const { callPort } = store.getters;
    const url = helpers.findCallWebsocketUrl(callServerType) + ':' + callPort;
    store.commit('setCallWebSocketUrl', url);

    eventBus.$emit('set-call-agent');

    // 상담데스크 UI 컨트롤
    store.commit('changeIsInitUi', true);
    store.commit('initDimmed');
  } catch (e) {}
}

async function getBrandList() {
  const { data } = await $http({
    url: '/api/v2/call/on-premise/brands',
    method: 'GET'
  });
  try {
    const brandList = data.map((brand) => {
      return { calledNumber: brand.rmk, representativeNumber: brand.rmk2, name: brand.brandName, brandId: brand.brandId };
    });
    return brandList;
  } catch (e) {
    console.error(e);
    return [];
  }
}

async function setNeoWebRtcAgentInfo() {
  const { callApiUrl } = store.getters;
  if (!callApiUrl) return;

  const { loginId } = Util.parseLoginToken();
  const { data } = await $http({
    url: '/gateway/call/agent',
    method: 'GET',
    params: {
      externalId: loginId
    },
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
  try {
    const agent = data.data;
    if (helpers.isObjectNotEmpty(agent) && agent.extensionNumber) {
      store.commit('changeIsExistCallAgent', true);
      store.commit('changeTelNumber', agent.extensionNumber);
      store.commit('setCallLoginId', agent.userId);
      store.commit('setCallBrandId', agent.agentGroupCd);
      store.commit('setCallAgentGroup', agent.agentCd);
      store.commit('changeEnabledCallAgent', agent.useYn === 'Y');
      store.commit('setCtiAgentGroup', agent.ctiAgentGroup); // CTI 상담사 소그룹
    } else {
      store.commit('changeIsExistCallAgent', false);
      store.commit('changeEnabledCallAgent', false);
    }
  } catch (e) {
    console.error(e);
    store.commit('changeIsExistCallAgent', false);
    store.commit('changeEnabledCallAgent', false);
    store.commit('initDimmed');
  }
}

// 콜 웹소켓 연결
function connectCallSocket() {
  setTimeout(() => {
    if (retryCount.call < 5) {
      store.dispatch('neo_web_rtc_connect');
      retryCount.call += 1;
    } else {
      console.log('call websocket connection failed');
    }
  }, 500);
}

function connectApiSocket() {
  const { IS_CALL_API_CONNECTED, callApiUserId, loginId } = store.getters;
  if (IS_CALL_API_CONNECTED && callApiUserId === loginId) return;
  setTimeout(() => {
    if (retryCount.api < 5) {
      store.dispatch('call_api_connect');
      retryCount.api += 1;
    } else {
      console.log('call api websocket connection failed');
    }
  }, 500);
}

function resetCount(type) {
  // type: call, api
  retryCount[type] = 0;
}

export default {
  initNeoWebRtc,
  connectCallSocket,
  connectApiSocket,
  resetCount
};



// WEBPACK FOOTER //
// ./src/util/call/neoWebRTC/initNeoWebRtc.js